<script>
  import { ComponentType } from '../../../../js/constants';

  import ImageLink, { WIDTH as IMAGE_LINK_WIDTH } from './ImageLink/ImageLink.svelte';
  import ArrowButton, { WIDTH as ARROW_BUTTON_WIDTH } from './ArrowButton/ArrowButton.svelte';

  export let navItems = [];

  const LIST_PADDING = 10;

  // these vars bound to elements below
  let scroller;
  let navWidth;

  // these determine whether arrows are shown
  let canScrollLeft = false;
  let canScrollRight = false;

  // calculate list width
  $: listWidth = navItems.length * IMAGE_LINK_WIDTH + LIST_PADDING * 2;

  // how far clicking an arrow button will scroll the scroller
  $: pageStep = Math.floor(navWidth / IMAGE_LINK_WIDTH) * IMAGE_LINK_WIDTH + LIST_PADDING;

  // perform arrow check whenever these widths change
  $: if (navWidth && listWidth && scroller) {
    arrowCheck();
  }

  // check the scroll position to determine
  // whether either arrow should be visible
  function arrowCheck() {
    if (navWidth < listWidth) {
      const progress = scroller.scrollLeft / (listWidth - navWidth);
      canScrollLeft = progress > 0;
      canScrollRight = progress < 1;
    } else {
      canScrollLeft = canScrollRight = false;
    }
  }

  // scroll the scroller one "page" to the left
  function pageLeft() {
    let step = pageStep;

    // if the right arrow is not currently visible,
    // adjust the step distance to account for it appearing
    if (!canScrollRight) {
      step = step - ARROW_BUTTON_WIDTH;
    }

    scroller.scrollBy({ left: -step, behavior: 'smooth' });
  }

  // scroll the scroller one "page" to the right
  function pageRight() {
    let step = pageStep;

    // if the left arrow is not currently visible,
    // adjust the step distance to account for it appearing
    if (!canScrollLeft) {
      step = step - ARROW_BUTTON_WIDTH;
    }

    scroller.scrollBy({ left: step, behavior: 'smooth' });
  }

  // when a link is tabbed to, scroll so that the link is centered.
  function onLinkTab(e) {
    const link = e.detail.target;

    scroller.scrollTo({
      left: link.offsetLeft + (link.offsetWidth - navWidth) / 2,
      behavior: 'smooth',
    });
  }
</script>

<nav class="ImageSubnav" data-component-type={ComponentType.IMAGE_SUBNAVIGATION} bind:offsetWidth={navWidth}>
  <div class="scroller" bind:this={scroller} on:scroll={arrowCheck}>
    <ul style="padding: {LIST_PADDING}px;">
      {#each navItems as item}
        <li>
          <ImageLink {...item} on:tabFocus={onLinkTab} />
        </li>
      {/each}
    </ul>
  </div>
  {#if canScrollLeft}
    <ArrowButton direction="left" on:click={pageLeft} />
  {/if}
  {#if canScrollRight}
    <ArrowButton direction="right" on:click={pageRight} />
  {/if}
</nav>

<style>.ImageSubnav {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  box-sizing: border-box;
  position: relative;
  min-width: 320px;
  border-bottom-width: 1px;
}

.scroller {
  overflow: auto;
  text-align: center;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: var(--color-border, #d9d9d9) var(--color-background, #fff);
}
.scroller::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroller::-webkit-scrollbar-track {
  background: var(--color-background, #fff);
}
.scroller::-webkit-scrollbar-thumb {
  border-radius: 5px;
  border: 2px solid var(--color-background, #fff);
  background: var(--color-border, #d9d9d9);
}

ul {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  display: inline-flex;
  align-items: stretch;
}
ul > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
ul > li::before {
  display: none;
}
ul > li {
  display: flex;
}</style>
